import { createI18n } from "vue-i18n";
import messages from "@intlify/unplugin-vue-i18n/messages";
import type { AppConfig } from "@/config/app-config.types";

export function createI18nForConfig(config: Pick<AppConfig, "clientName">) {
  return createI18n({
    legacy: false,
    globalInjection: true,
    locale: config.clientName || "rapihogar",
    fallbackLocale: "rapihogar",
    availableLocales: ["rapihogar", "galicia"],
    messages: messages,
  });
}
